import { put, take } from 'redux-saga/effects';

import {
    GET_USER_PERSONALISATION_ERROR,
    GET_USER_PERSONALISATION_SUCCESS,
    GET_USER_WEB_ANALYTICS_ERROR,
    GET_USER_WEB_ANALYTICS_SUCCESS,
} from 'store/user/actionTypes';
import { GET_AUTH_TOKEN_ERROR, GET_AUTH_TOKEN_SUCCESS } from 'store/auth/actionTypes';
import { getAuthTokenRequest } from 'store/auth/actions';

import { getUserPersonalisationRequest, getUserWebAnalyticsRequest } from '../actions';

export function* waitForGetUserPersonalisation() {
    yield put(getUserPersonalisationRequest());

    const action: { type: string } = yield take([GET_USER_PERSONALISATION_SUCCESS, GET_USER_PERSONALISATION_ERROR]);

    if (action.type === GET_USER_PERSONALISATION_ERROR) {
        throw new Error('Error while fetching user personalisation data');
    }
}

export function* waitForGetAuthTokenRequest() {
    yield put(getAuthTokenRequest());

    const action: { type: string } = yield take([GET_AUTH_TOKEN_SUCCESS, GET_AUTH_TOKEN_ERROR]);

    if (action.type === GET_AUTH_TOKEN_ERROR) {
        throw new Error('Error while fetching auth token');
    }
}

export function* waitForGetUserWebAnalytics() {
    yield put(getUserWebAnalyticsRequest());

    const action: { type: string } = yield take([GET_USER_WEB_ANALYTICS_SUCCESS, GET_USER_WEB_ANALYTICS_ERROR]);

    if (action.type === GET_USER_WEB_ANALYTICS_ERROR) {
        throw new Error('Error while fetching user web analytics');
    }
}
